<template>
    <div class="setRent_formation_box2">
        <div class="inform_tit"> 
            <div @click="cancel" class='cancel_box'>
                <i class="el-icon-back myback_icon"></i> Back
            </div>
        </div>
        <div class="inMain_box">
            <div class="informdata_tit">Manual Stocktakes COGs</div>
            <table class="holiday" cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th>Week</th>
                        <th>Cost</th>
                        <th>Operating</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, key) in table" :key="key">
                        <td>{{item.week}}</td>
                        <td><span v-if="item.cost !== '-'">$</span>{{item.cost}}</td>
                        <td>
                            <div class="btns">
                                <div class="btn" v-if="item.type === 1">Edit</div>
                                <div class="btn" v-if="item.type === 0">Enter</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="table.length === 0" class="loading">
                <i v-if="loading && table.length === 0" class="el-icon-loading" style="font-size:20px"></i>
                <div v-if="!loading && table.length === 0">-</div>
            </div>
            <div class="resetButton">Re-Stocktakes</div>
        </div>

        <transition name="fade" v-if="showEdit">
            <div class="pop-wrp2">
                <div class="second-step">
                    <h1>Edit COGs Cost</h1>
                    <el-form :model="ruleForm" label-position="top" :hide-required-asterisk="true" :rules="rules" ref="ruleForm" label-width="100px" class="information-ruleForm">
                        <el-form-item label="Cost" prop="cost" style="position:relative">
                            <span class="dollar">$</span>
                            <el-input class="remark pdft" v-model="ruleForm.cost"></el-input>
                        </el-form-item>
                        <el-form-item class="foot_box">
                            <el-button class="cardCanBtn">Cancel</el-button>
                            <el-button class="cardConBtn">Save</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </transition>
        
        <transition name="fade" v-if="showReset">
            <div class="pop-wrp2">
                <div class="pop-confirm">
                    <h1 style="padding-top: 50px;margin-bottom: 60px;">After Re-Stocktakes, the current data will be cleared and a<br />new record will be started. Are you sure to continue?</h1>
                    <div class="double">
                        <button>Cancel</button>
                        <button>Confirm</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import api from '../../api/api'
export default {
    data() {
        return {
            table: [
                {
                    week: 'Week 1',
                    cost: '5454',
                    type: 1
                },
                {
                    week: 'Week 2',
                    cost: '87',
                    type: 1
                },
                {
                    week: 'Week 3',
                    cost: '99',
                    type: 1
                },
                {
                    week: 'Week 4',
                    cost: '-',
                    type: 0
                }
            ],
            loading: true,
            showReset: false,
            showEdit: false,
            ruleForm:{
				cost: ''
            },
            rules:{
                cost: [{ required: true, message: ' ', trigger: 'change' }]
            }
        }
    },
    created() {
        // this.getList()
    },
    methods: {
        getList() {
            this.loading = true
            this.table = []
            api.manualCogsList({
                callback: (res) => {
                    this.loading = false
                    if(res.data.code == 0){
                        /* res.data.data.forEach(item => {
                        }) */
                    } else if (res.data.code == 8902) {
                        sessionStorage.clear()
                        this.$router.push('/login')
                    } else{
                        Utils.alert('', res.data.message, 'error')
                    }
                }
            })
        },
        cancel() {
            this.$router.replace('/setting')
        }
    }
}
</script>

<style lang="scss" scoped>
.setRent_formation_box2{
    position: relative;
    .inform_tit{
        height:76px;
        font-size:14px;
        font-weight:600;
        color:var(--text-color);
        line-height:20px;
        width: 100%;
        background-color: var(--background-color);
        z-index: 100;
        .cancel_box{
            cursor: pointer;
            width: 150px;
        }
    }
    .inMain_box{
        background-color: var(--background-color-2);
        width: 100%;
        box-sizing: border-box;
        padding:50px 30px;
        .informdata_tit{
            text-align: center;
            margin-bottom: 50px;
            height:42px;
            font-size:30px;
            font-family:PingFangSC-Semibold,PingFang SC;
            font-weight:600;
            color:var(--text-color);
            line-height:42px;
        }
        .holiday{
            border: 1px solid #5F5F5F;
            width: 100%;
            background: var(--background-color-2);
            th, td{
                font-family: PingFangSC-Semibold, PingFang SC;
                color: var(--text-color);
                text-align:center;
                box-sizing: border-box;
                line-height: 26px;
                width: 25%;
            }
            th{
                font-size: 16px;
                padding: 14px 10px;
            }
            td{
                font-size: 18px;
                padding: 18px 10px;
                border-top: 1px solid #5F5F5F;
                border-right: 1px solid #5F5F5F;
                :nth-last-child(1){
                    border-right: 0;
                }
            }
            .btns{
                text-align: center;
                .btn{
                    display: inline-block;
                    padding: 0 20px;
                    font-size: 20px;
                    color: #E83695;
                    cursor: pointer;
                }
            }
        }
        .add{
            width: 100%;
            height: 60px;
            text-align: center;
            line-height: 60px;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #E83695;
            cursor: pointer;
            box-sizing: border-box;
            border-bottom: 1px solid #5F5F5F;
            border-left: 1px solid #5F5F5F;
            border-right: 1px solid #5F5F5F;
            background: var(--background-color-2);
            i{
                display: inline-block;
                width: 20px;
                height: 20px;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: contain;
                background-image: url('../../assets/r.png');
                margin-right: 6px;
                position:relative;
                top: 3px;
            }
        }
    }
    .resetButton{
        width: 280px;
        height: 60px;
        background: var(--background-color-4);
        border: 2px solid #EA3796;
        line-height: 60px;
        margin: 0 auto;
        font-size: 26px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #EA3796;
        text-align: center;
        cursor: pointer;
        margin-top: 65px;
    }
}
.pop-wrp2{
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    background:rgba(33,36,41,.8);
    bottom: 0;
    right: 0;
    z-index: 101;
    h1{
        font-size: 24px;
        line-height: 33px;
        font-weight: 600;
        margin-bottom: 40px;
        color: var(--text-color);
        text-align: center;
    }
    .btns{
        margin: 65px auto 0 auto;
        width: 610px;
        button{
        width:280px;
        height:60px;
        outline: none;
        background: none;
        cursor: pointer;
        font-weight: 600;
        }
        
        .dark{
        border: 2px solid var(--text-color);
        color: var(--text-color);
        font-size: 26px;
        float: left;
        }
        .light{
        border: 2px solid #8E3771;
        color: #8E3771;
        font-size: 26px;
        float: right;
        }
        .usable{
        border: 2px solid #EA3796;
        color: #EA3796;
        }
    }
    .normal{
        transform: rotate(0deg);
        opacity: 1;
        margin-left: -420px;
    }
    .second-step{
        width:840px;
        height:408px;
        background:rgba(43,52,68,1);
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -203px 0 0 -420px;
        box-sizing: border-box;
        padding: 65px 50px 0 50px;
    }
    .pop-confirm{
      width: 1250px;
      height: 280px;
      background: var(--background-color-4);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -140px 0 0 -625px;
      .double{
        text-align: center;
        button{
          width: 280px;
          height: 60px;
          background: var(--background-color-4);
          box-sizing: border-box;
          font-size: 26px;
          font-family:PingFangSC-Semibold,PingFang SC;
        }
        button:nth-child(1), button:nth-child(2){
          margin-right: 50px;
        }
        button:nth-child(1){
          color: var(--text-color);
          border: 2px solid var(--text-color);
        }
        button:nth-child(3), button:nth-child(2){
          color:#D13A90;
          border: 2px solid #D13A90;
        }
      }
    }
}
.fade-enter-active, .fade-leave-active {
transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
opacity: 0;
}
.loading{
    text-align: center;
    line-height: 50px;
    color: var(--text-color);
    border-left: 1px solid #5F5F5F;
    border-right: 1px solid #5F5F5F;
    border-bottom: 1px solid #5F5F5F;
    background: var(--background-color-2);
}
.dollar{
    position: absolute;
    font-size: 18px;
    left: 10px;
    top: 6px;
    z-index: 3;
    color:var(--text-color);
}
</style>


// WEBPACK FOOTER //
// src/components/setting/cogs.vue